import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const DataSourcesContext = /*#__PURE__*/createContext(undefined);
function DataSourcesProvider({
  children,
  flowId,
  flowObjectTypeId,
  getActionHeaderTitle
}) {
  return /*#__PURE__*/_jsx(DataSourcesContext.Provider, {
    value: {
      flowId,
      flowObjectTypeId,
      getActionHeaderTitle
    },
    children: children
  });
}
function useDataSourcesContext() {
  const context = useContext(DataSourcesContext);
  return context;
}
export { DataSourcesProvider, useDataSourcesContext };